// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2G9nd","inputWrap":"CustomTip_inputWrap__JKVTb"};